import { TransformPlainObject } from 'worker/app-workers/shared/plainObjects/transform.plainObject';
import { TransformConvertorBase } from './adapterVisitor/convertors/transform.convertor';
import { Flowlet } from 'app/model/dataflow/flowlet';
import { DataFlowParser } from './dataflow.parser';

export enum ParseScriptMethod {
    ALL,
    PARAMETERS,
    TRANSFORMATIONS
}

export class FlowletParser extends DataFlowParser {
    protected _getTransformationConvertor(transformationObject: TransformPlainObject, dataflow: Flowlet): TransformConvertorBase {
        const transformName = transformationObject.modelName;
        const converter = super._getTransformationConvertor(transformationObject, dataflow);

        if (!converter) {
            switch (transformName) {
                // Add input and output here
                default:
                    return undefined;
            }
        } else {
            return converter;
        }
    }
}
